<template>
	<!-- 完结 -->
	<div class="wanjieBox">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
		<!-- 完结金榜 -->
		<div class="yunjin_jbBox">
			<h4>完结金榜<img src="../../assets/img/icon8.png" alt=""></h4>
			<div class="yunjin_jb">
				<swiper class="swiper" :options="jb_swiperOption">
					<swiper-slide v-for="(item,index) in ranking_wjjb" v-if="item.book_id != null" :key="index">
						<div @click="jumpBookinfo(item.book_id)">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in item.name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
						<p class="jianjie"><span v-for="(introduce,introduceIndex) in item.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<!-- 完结欣赏 -->
		<div class="shouyeQt">
			<h4>完结欣赏</h4>
			<div class="qt_list">
				<p v-for='(item,index) in ranking_wjsx' :key='index'>
					<span @click="jumpBookinfo(item.book_id)">{{item.name}}</span>
				</p>
			</div>
		</div>
		<!-- 完结图推 -->
		<div class="yunjin_jbBox" style="padding-top: 10px;">
			<h4>完结图荐</h4>
			<div class="yunjin_jb">
				<swiper class="swiper" :options="jb_swiperOption">
					<swiper-slide v-for="(item,index) in ranking_wjtj" :key="index" v-if="item.book_id != null">
						<div v-if="item.cover_image != null"  @click="jumpBookinfo(item.book_id)"><img :src="$api.$BASE_URL_img + item.cover_image" alt=""></div>
						<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in item.name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
						<p class="jianjie"><span v-for="(intjroduce,introduceIndex) in item.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<!-- 精品 -->
		<div class="jinpinBox">
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(0)">
					<h4>言情</h4>
					<div >
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName" v-if="index<1" v-for='(item,index) in ranking_qywj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_qywj'>
					<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(1)">
					<h4>纯爱</h4>
					<div > 
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName"  v-if="index<1" v-for='(item,index) in ranking_cawj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_cawj'>
						<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
		</div>

		<div class="jinpinBox">
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(2)">
					<h4>衍生</h4>
					<div >
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName"  v-if="index<1" v-for='(item,index) in ranking_yswj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_yswj'>
						<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(3)">
					<h4>言情半价</h4>
					<div >
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName"  v-if="index<1" v-for='(item,index) in ranking_qybj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_qybj'>
						<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
		</div>
		<div class="jinpinBox">
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(4)">
					<h4>纯爱半价</h4>
					<div >
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName"  v-if="index<1" v-for='(item,index) in ranking_cabj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_cabj'>
						<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
			<div class="jinpin_left">
				<div class="jp_title" @click="jumpMore(5)">
					<h4>衍生半价</h4>
					<div>
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="jp_bookName"  v-if="index<1" v-for='(item,index) in ranking_ysbj'>
					<div class="jp_bookImg"  @click="jumpBookinfo(item.book_id)">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
					</div>
					<div>
						<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
						<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
					</div>
				</div>
				<div class="bookNameList">
					<p v-if="index>=1 && index<=3" v-for='(item,index) in ranking_ysbj'>
						<span  @click="jumpBookinfo(item.book_id)">{{item.book_name}}</span>	
						</p>
				</div>
			</div>
		</div>

		<!-- <div class="limiteFooter">
			<span class="btnLimite" @click="jumpwjpgd">完结精品更多 &gt; &gt; &gt; &gt;</span>
			<div class="limiteArr">
				<img src="../../assets/img/arr.png" alt="">
			</div>
		</div> -->
		<!-- 最近更新 -->
		<div class="updata_box">
			<div>
				<div class="updata_tit">
					<span v-for="(updataItem,index) in updataLists" :key="index" @click="undataItem(index)" class="afterFather">
						<span class="line" :class="undataItemSH == index ? 'active' : ''">{{updataItem}}</span>
					</span>
				</div>
			</div>
			<!-- v-if="undataItemSH == 0 ? true : false" -->
			<div class="updata_book">
				<p v-for="(item,index) in ranking_zxwj"  v-if="index <= 15" :key="index" @click="jumpBookinfo(item.id)">
					<span  v-if="idx > 8 ? false : true" v-for="(book_name,idx) in item.book_name">{{book_name}}</span>
				</p>
			</div>
			<!-- <div class="updata_book" v-if="undataItemSH == 1 ? true : false">
				<p v-for="(item,index) in new_yqwj" :key="index" @click="jumpBookinfo(item.id)">
					<span  v-if="idx > 8 ? false : true" v-for="(name,idx) in item.name">{{name}}</span>
				</p>
			</div>
			<div class="updata_book" v-if="undataItemSH == 2 ? true : false">
				<p v-for="(item,index) in new_cawj" :key="index" @click="jumpBookinfo(item.id)">
					<span  v-if="idx > 8 ? false : true" v-for="(name,idx) in item.name">{{name}}</span>
				</p>
			</div>
			<div class="updata_book" v-if="undataItemSH == 3 ? true : false">
				<p v-for="(item,index) in new_yswj" :key="index" @click="jumpBookinfo(item.id)">
					<span  v-if="idx > 8 ? false : true" v-for="(name,idx) in item.name">{{name}}</span>
				</p>
			</div>
			<div class="updata_book" v-if="undataItemSH == 4 ? true : true">
				<p v-for="(item,index) in new_wcpwj" :key="index" @click="jumpBookinfo(item.id)"> 
				<span  v-if="idx > 8 ? false : true" v-for="(name,idx) in item.name">{{name}}</span>
				</p>
			</div> -->
		</div>
		<!-- <div class="limiteFooter">
			<span class="btnLimite" @click="jumpwjgd">完结更多 &gt; &gt; &gt; &gt;</span>
			<div class="limiteArr">
				<img src="../../assets/img/arr.png" alt="">
			</div>
		</div> -->
		</van-pull-refresh>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				undataItemSH: 0,
				images: [
					require('../../assets/img/banner.png'),
					require('../../assets/img/banner.png'),
				],
				//轮播图配置
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				tutui_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				bookSwiperLists: [],
				updata: [],
				updataLists: ["最近更新"],
				//"言情", "纯爱", "衍生", "无CP"
				ranking_cabj: [],
				ranking_cawj: [],
				ranking_qybj: [],
				ranking_qywj: [],
				ranking_wjjb: [],
				ranking_wjsx: [],
				ranking_wjtj: [],
				ranking_wjtt: [],
				ranking_ysbj: [],
				ranking_yswj: [],
				ranking_zxwj: [],
				new_cawj:[],
				new_wcpwj:[],
				new_yqwj:[],
				new_yswj:[],
				isLoading: false,
			}
		},
		created() {
			this.get_wanjie();
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.get_wanjie();
					this.isLoading = false;
				}, 1000);
			},
			undataItem(data) {
				alert(data)
				this.undataItemSH = data;
			},
			jumpwjpgd() {
				//完结精品更多
				this.$router.push('/wanjiejingpingengduo')
			},
			jumpwjgd() {
				//完结更多页面
				this.$router.push('/wanjiegengduo')
			},
			// 点击跳转
			jumpMore(val){
				this.$router.push({
					path:'/wanjiegengduo',
					query:{
						active:val
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {
			
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						getSecond_tab: 1,
						getFirstvalue_tab: 0,
						url: 'wanjie',
					}
				})
			},
			get_wanjie() {
				this.$axios.post(this.$api.wanjie).then(res => {
					console.log(res, '完结首页')
					if (res.status == 200) {
						res.data.data.ranking_cabj.forEach(item => {
							if(item.book_id != null){
								this.ranking_cabj.push(item)
							}
						})
						res.data.data.ranking_qybj.forEach(item => {
							if(item.book_id != null){
								this.ranking_qybj.push(item)
							}
						})
						res.data.data.ranking_qywj.forEach(item => {
							if(item.book_id != null){
								this.ranking_qywj.push(item)
							}
						})
						res.data.data.ranking_cawj.forEach(item => {
							if(item.book_id != null){
								this.ranking_cawj.push(item)
							}
						})
						res.data.data.ranking_ysbj.forEach(item => {
							if(item.book_id != null){
								this.ranking_ysbj.push(item)
							}
						})
						res.data.data.ranking_yswj.forEach(item => {
							if(item.book_id != null){
								this.ranking_yswj.push(item)
							}
						})
						this.ranking_wjjb = res.data.data.ranking_wjjb;
						this.ranking_wjsx = res.data.data.ranking_wjsx;
						this.ranking_wjtj = res.data.data.ranking_wjtj;
						this.ranking_wjtt = res.data.data.ranking_wjtt;
						this.ranking_zxwj = res.data.data.ranking_zxwj;
					}

				})
			}
		}
	}
</script>
<style scoped lang="less">
	.wanjieBox{
		background-color: #f0f0f0;
		overflow-y: scroll;
		height: calc(100vh - 200px);
	}
	// 云锦金榜
	.yunjin_jbBox {
		height: 370px !important;
		background-color: #fff;
		margin-bottom: 10px;
		padding: 20px 16px;
		padding-top: 80px;
		h4 {
			display: inline-block;
			color: #ff4081;
			font-size: 30px;
			/*px*/
			height: 50px;
			line-height: 50px;
			font-weight: 700;
			position: relative;
			
			img {
				width: 40px;
				position: absolute;
				top: -15px;
				right: -26px;
			}
		}

		.yunjin_jb {
			margin-top: 10px;
			// height: 320px !important;
			height: 320px !important;
			.swiper-container {
				.swiper-slide {
					// width: 25%;
					// margin-right: 20px !important;
					width: 28% !important;
					margin-right: 15px !important;
					div{
						text-align: center;
						img {
							width: 190px;
							height: 270px;
							vertical-align: middle;
							-webkit-box-shadow:0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
						}
					}
					.bookName,
					.jianjie {
						font-size: 30px;
						/*px*/
						overflow: hidden;
						white-space: nowrap;
						// text-overflow: ellipsis;s
						padding-top: 15px;
						color: #000;
						text-align: center;
					}
			
					.jianjie {
						font-size: 24px;
						/*px*/
						color: #000;
						opacity: 0.6;
						padding-top: 15px;
					}
				}
			}
		}
	}

	//完结欣赏
	.shouyeQt {
		background-color: #fff;
		margin-bottom: 10px;
		padding: 0 16px;

		h4 {
			color: #ff4081;
			font-size: 30px;
			/*px*/
			height: 74px;
			line-height: 74px;
			font-weight: 700;
		}

		.qt_list {
			overflow: hidden;

			p {
				width: calc(50% - 20px);
				// padding-left: 20px;
				float: left;
				line-height: 60px;
				font-size: 30px;
				/*px*/
				color: #000;
				height: 60px;
			}
			p:nth-child(2n){
				padding-left: 30px;
			}
		}

	}

	// 言情 纯爱
	.jinpinBox {
		margin-top: 10px;
		overflow: hidden;
		background-color: #fff;
	
		.jinpin_left {
			width: calc(50% - 31px);
			margin-bottom: 10px;
			background-color: #fff;
			float: left;
			padding-left: 16px;
			padding-right: 25px;
			padding-bottom: 16px;
			overflow: hidden;
			.jp_title {
				display: flex;
				height: 78px;
				line-height: 78px;
				position: relative;
				h4 {
					flex: 1;
					font-size: 30px;
					/*px*/
					color: #ff4081;
				}
	
				div {
					padding-right: 10px;
	
					img {
						width: 50px;
						position: absolute;
						top: 50%;
						right:0;
						transform: translateY(-50%);
					}
				}
			}
	
			.jp_bookName {
				display: flex;
				height: 240px;
				position: relative;
	
				.jp_bookImg {
					position: absolute;
					top: 50%;
					left: 0;
					transform: translateY(-50%);
					width: 155px;
					height: 220px;/*px*/
					-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					img {
						width: 155px;
						height: 220px;/*px*/
						display: block;
					}
				}
	
				div:last-child {
					position: absolute;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
					text-align: left;
					width: 50%;
	
					p:first-child {
						// width: 120px;
						font-size: 30px;
						/*px*/
						// font-weight: bold;
						margin-bottom: 10px;
						line-height: 40px;
						height: 40px;
						overflow: hidden;
						color:rgba(0,0,0,1);
					}
	
					p:nth-child(2) {
						font-size: 26px;
						/*px*/
						padding-bottom: 10px;
						color:rgba(0,0,0,1);
						opacity:0.6;
					}
	
					p:last-child {
						overflow: hidden;
						line-height: 40px;
						height: 80px;
						color:rgba(0,0,0,1);
						opacity:0.4;
						font-size: 24px;
						/*px*/
					}
				}
			}
	
			.bookNameList {
				font-size: 30px;
				/*px*/
				overflow: hidden;
				white-space: nowrap;
				margin-right: 10px;
				color: #000;
				p{
					height: 60px;
					line-height: 60px;;
				}
			}
		}
	
		.jinpin_left:nth-child(2n) {
			padding-right: 16px;
			padding-left: 5px;
		}
	
	}

	// 最近更新
	.updata_box {
		margin-top: 10px;

		div:first-child {
			display: flex;
			background-color: #fff;
			line-height: 30px;
			padding: 16px;
			color: #ff4081;

			.updata_tit {
				padding: 20px 0;

				.afterFather {
					position: relative;
					padding: 0 16px;

					span {
						padding-right: 16px;
						font-size: 32px;
						/*px*/
					}

					.active {
						transform: scale(1.1);
						font-weight: bold;
					}

					.line::after {
						content: "|";
						display: block;
						position: absolute;
						top: 50%;
						right: 0%;
						transform: translateY(-50%);
						color: #dbdbdb;
					}
				}

				.afterFather:first-child {
					padding-left: 0;
				}
				.afterFather:last-child {
					.line::after {
						content: "";
						display: block;
						position: absolute;
						top: 50%;
						right: 0%;
						transform: translateY(-50%);
						color: #dbdbdb;
					}
				}
			}
		}

		.updata_book {
			color: #666666;
			background-color: #fff;
			padding: 10px 16px;
			overflow: hidden;

			p {
				width: calc(50% - 40px);
				margin-right: 10px;
				padding-right: 10px;
				height: 60px;
				overflow: hidden;
				white-space: nowrap;
				float: left;
				text-align: left;
				font-size: 30px;
				/*px*/
				line-height: 60px;
				color: #000;
			}
			p:nth-child(2n){
				padding-left: 30px;
			}
		}
	}

	// 完结更多
	.limiteFooter {
		margin-top: 10px;
		display: flex;
		// justify-content: space-between;
		background-color: #fff;
		line-height: 80px;
		padding: 0 16px;

		.btnLimite {
			flex: 1;
			text-align: center;
			font-size: 30px;
			/*px*/
			color: #ff70a0;
		}

		.limiteArr {
			img {
				transform: rotate(270deg);
				width: 32px;
			}
		}
	}
</style>
